import p1 from "./Pimg/5Alive N1,500.jpg"
import p2 from "./Pimg/A Portion of Fried Chips N3,000.jpg"
import p3 from "./Pimg/Amma Jamma - Rodo Sauce N4,500.jpg"
import p4 from "./Pimg/Amma Jamma - Shitor Sauce N4,500.jpg"
import p5 from "./Pimg/Big Boyz Combo N9,800.jpg"
import p6 from "./Pimg/Big Crew Meal N33,100.jpg"
import p7 from "./Pimg/Big Whizz Meal N6,400.jpg"
import p8 from "./Pimg/ChickWhizz Meal N7100.jpg"
import p9 from "./Pimg/Chicken Pie N1,800.jpg"
import p10 from "./Pimg/Chief Burger Combo N6,250.jpg"
import p11 from "./Pimg/Chief Burger N5,800.jpg"
import p12 from "./Pimg/Citizens Meal N8,200.jpg"
import p13 from "./Pimg/Citizens Meal without drink N7200.jpg"
import p14 from "./Pimg/Citizens Meal.jpg"
import p15 from "./Pimg/Citizens Spicy Yam Meal N6,800.jpg"
import p16 from "./Pimg/Coca Cola (50cl) N1,600.jpg"
import p17 from "./Pimg/Coleslaw N1,500.jpg"
import p18 from "./Pimg/Dodo Cubes N2,000.jpg"
import p19 from "./Pimg/Express Combo N5,300.jpg"
import p20 from "./Pimg/Fanta Orange (50cl) N1,600.jpg"
import p21 from "./Pimg/Fried Rice N3,100.jpg"
import p22 from "./Pimg/Fried Yam N2,700.jpg"
import p23 from "./Pimg/Full Rotisserie Chicken N22,400.jpg"
import p24 from "./Pimg/Jellof Rice N3,000.jpg"
import p25 from "./Pimg/MINI Pot Lovers Meal N16,800.jpg"
import p26 from "./Pimg/Maxi Pot Lovers Meal N31,600.jpg"
import p27 from "./Pimg/Meat Pie N1,800.jpg"
import p28 from "./Pimg/Mega Pot Lovers Meal N44,400.jpg"
import p29 from "./Pimg/Mineral Water (750ml) N700.jpg"
import p30 from "./Pimg/Moin- Moin N2,400.jpg"
import p31 from "./Pimg/Monster Energy N2,000.jpg"
import p32 from "./Pimg/Original ChickWhizz Breakfast Combo N4600.jpg"
import p33 from "./Pimg/Paper Sauce N900.jpg"
import p34 from "./Pimg/Pasta Salad N1,400.jpg"
import p35 from "./Pimg/Pastry Breakfast Combo N2,650.jpg"
import p36 from "./Pimg/Pot Chicken (8 Pieces) N19,700.jpg"
import p37 from "./Pimg/Predator N1,600.jpg"
import p38 from "./Pimg/Quarter Rotisserie Chicken N6,200.jpg"
import p39 from "./Pimg/Quarter Rotisserie Combo N8,500.jpg"
import p40 from "./Pimg/Refuel Dodo Max Combo N5,000.jpg"
import p41 from "./Pimg/Refuel Dodo Meal N4,500.jpg"
import p42 from "./Pimg/Refuel Jumbo N3,200.jpg"
import p43 from "./Pimg/Refuel Max Combo N5,000.jpg"
import p44 from "./Pimg/Rice & Beans with Sauce N3,300.jpg"
import p45 from "./Pimg/Schweppes 40cl N1,600.jpg"
import p46 from "./Pimg/Soulfully Spiced Fried Chicken N3,400.jpg"
import p47 from "./Pimg/Spaghetti N3,100.jpg"
import p48 from "./Pimg/Spicy Yam Combo N5,600.jpg"
import p49 from "./Pimg/Spicy Yam Meal N4,700.jpg"
import p50 from "./Pimg/Sprite (50cl) N1,600 .jpg"
import p51 from "./Pimg/White Rice with Sauce N3,100.jpg"






const products = [

  {
    id: 36,
    name: "Pot Chicken (8 Pieces)",
    category: "pot meals",
    price: 19700,
    image: p36 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
 
  {
    id: 38,
    name: "Quarter Rotisserie Chicken",
    category: "rotisserie chicken",
    price: 6200,
    image: p38 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 39,
    name: "Quarter Rotisserie Combo",
    category: "rotisserie chicken",
    price: 8500,
    image: p39 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 40,
    name: "Refuel Dodo Max Combo",
    category: "everyday affordable",
    price: 5000,
    image: p40 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 41,
    name: "Refuel Dodo Meal",
    category: "everyday affordable",
    price: 4500,
    image: p41 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 42,
    name: "Refuel Jumbo",
    category: "everyday affordable",
    price: 3200,
    image: p42 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 43,
    name: "Refuel Max Combo",
    category: "everyday affordable",
    price: 5000,
    image: p43 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 44,
    name: "Rice & Beans with Sauce",
    category: "sides",
    price: 3300,
    image: p44 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 45,
    name: "Schweppes 40cl",
    category: "drinks",
    price: 1600,
    image: p45 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 46,
    name: "Soulfully Spiced Fried Chicken",
    category: "everyday affordable",
    price: 3600,
    image: p46 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 47,
    name: "Spaghetti",
    category: "sides",
    price: 3100,
    image: p47 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 48,
    name: "Spicy Yam Combo",
    category: "everyday affordable",
    price: 5600,
    image: p48 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 49,
    name: "Spicy Yam Meal N4,700",
    category: "everyday affordable",
    price: 178500,
    image: p49 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 50,
    name: "Sprite (50cl)",
    category: "drinks",
    price: 1600,
    image: p50 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
    
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
  {
    id: 51,
    name: "White Rice with Sauce",
    category: "sides",
    price: 3100,
    image: p51 ,
    shopId: "shop005",
    shopName: "Chicken Republic",
      vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
  },
   
    {
      id: 1,
      name: "5 Alive",
      category: "drinks",
      price: 1500,
      image: p1 ,
        shopId: "shop005",
        shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 2,
      name: "A Portion of Fried Chips",
      category: "everyday affordable",
      price: 3000,
      image: p2 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 3,
      name: "Amma Jamma - Rodo Sauce",
      category: "sides",
      price: 4500,
      image: p3 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 4,
      name: "Amma Jamma - Shitor Sauce",
      category: "sides",
      price: 4500,
      image: p4 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 5,
      name: "Big Boyz Combo",
      category: "burger & sandwiches",
      price: 9800,
      image: p5 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 6,
      name: "Big Crew Meal",
      category: "pot meals",
      price: 33300,
      image: p6 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 37,
      name: "Predator",
      category: "drinks",
      price: 1600,
      image: p37 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 7,
      name: "Big Whizz Meal.jpg",
      category: "pot meals",
      price: 6400,
      image: p7 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 8,
      name: "ChickWhizz Meal",
      category: "burger & sandwiches",
      price: 7100,
      image: p8 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 9,
      name: "Chicken Pie",
      category: "everyday affordable",
      price: 1800,
      image: p9 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 10,
      name: "Chief Burger Combo",
      category: "everyday affordable",
      price: 6250,
      image: p10 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 11,
      name: "Chief Burger",
      category: "burger & sandwiches",
      price: 5800,
      image: p11 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 12,
      name: "Citizens Meal",
      category: "citizens meal",
      price: 8200,
      image: p12 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 13,
      name: "Citizens Meal without drink",
      category: "citizens meal",
      price: 7200,
      image: p13 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 14,
      name: "Citizens Meal",
      category: "citizens meal",
      price: 8200,
      image: p14 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 15,
      name: "Citizens Spicy Yam Meal",
      category: "citizens meal",
      price: 6800,
      image: p15 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 16,
      name: "Coca Cola (50cl)",
      category: "drinks",
      price: 1600,
      image: p16 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 17,
      name: "Coleslaw.jpg",
      category: "sides",
      price: 1500,
      image: p17 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 18,
      name: "Dodo Cubes",
      category: "sides",
      price: 2000,
      image: p18 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 19,
      name: "Express Combo",
      category: "everyday affordable",
      price: 5300,
      image: p19 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 20,
      name: "Fanta Orange (50cl)",
      category: "drinks",
      price: 1600,
      image: p20 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 21,
      name: "Fried Rice",
      category: "sides",
      price: 3100,
      image: p21 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 22,
      name: "Fried Yam",
      category: "sides",
      price: 2700,
      image: p22 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 23,
      name: "Full Rotisserie Chicken",
      category: "rotisserie chicken",
      price: 22400,
      image: p23 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 24,
      name: "Jellof Rice",
      category: "everyday affordable",
      price: 3000,
      image: p24 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 25,
      name: "MINI Pot Lovers Meal",
      category: "pot meals",
      price: 16900,
      image: p25 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 26,
      name: "Maxi Pot Lovers Meal",
      category: "pot meals",
      price: 31600,
      image: p26 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 27,
      name: "Meat Pie",
      category: "sides",
      price: 1800,
      image: p27 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 28,
      name: "Mega Pot Lovers Meal",
      category: "pot meals",
      price: 44500,
      image: p28 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 29,
      name: "Mineral Water (750ml) N700",
      category: "drinks",
      price: 44400,
      image: p29 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 30,
      name: "Moin- Moin",
      category: "sides",
      price: 2400,
      image: p30 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 31,
      name: "Monster Energy",
      category: "drinks",
      price: 2000,
      image: p31 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 32,
      name: "Original ChickWhizz Breakfast Combo",
      category: "everyday affordable",
      price: 4600,
      image: p32 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 33,
      name: "Paper Sauce",
      category: "sides",
      price: 900,
      image: p33 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 34,
      name: "Pasta Salad",
      category: "sides",
      price: 1400,
      image: p34 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    {
      id: 35,
      name: "Pastry Breakfast Combo",
      category: "everyday affordable",
      price: 2650,
      image: p35 ,
      shopId: "shop005",
      shopName: "Chicken Republic",
      
        vendorId: "RlKVpUKGGKNingteZAp0zsuRPGP2"
    },
    

    
  ];
  
  export default products;

  